(() => {
  'use strict';
  if (window.SacGarageTracking) return;
  const config = document.querySelector('[data-sac-garage-tracking]');
  if (!config) return;
  const KEY = 'sac.garage.analytics.v1';
  const CART_KEY = '__sac_garage_visit__';
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const CODE = /^SC-[A-F0-9]{32}$/i;
  const DAY = 86400000;
  const url = new URL(location.href);
  const endpoint = new URL('/apps/sac-city-rewards/funnel', location.origin);
  const cartUrl = new URL('cart/update.js', new URL(config.dataset.cartRoot || '/', location.origin));
  const cartReadUrl = new URL('cart.js', new URL(config.dataset.cartRoot || '/', location.origin));
  if (cartUrl.origin !== location.origin) return;
  let excluded = config.dataset.excluded === 'true' || window.Shopify?.designMode === true || url.searchParams.has('preview_theme_id') || url.searchParams.get('sac_garage_qa') === '1';
  try {
    if (url.searchParams.get('sac_garage_qa') === '1') sessionStorage.setItem('sac.garage.qa', '1');
    excluded ||= sessionStorage.getItem('sac.garage.qa') === '1';
  } catch {}
  let allowed = false, marketing = false, initialized = false, record = null, registration = null, registered = false, epoch = 0;
  let cartDesired = null, cartWritten = null, cartPending = false, cartTimer = null, cartAttempts = 0, cartSignature = '';
  let cartFailures = 0, cartReadPending = false, cartReadTimer = null;
  let opens = new WeakSet();
  const controllers = new Set();
  const uid = () => { try { return typeof crypto === 'object' && typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : null; } catch { return null; } };
  const permission = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== 'function' || typeof privacy?.marketingAllowed !== 'function') return null;
      return {analytics: privacy.analyticsProcessingAllowed() === true, marketing: privacy.marketingAllowed() === true};
    } catch { return null; }
  };
  const canTrack = () => !excluded && allowed && permission()?.analytics === true;
  const storageRemove = () => { try { localStorage.removeItem(KEY); } catch {} };
  function save() { if (!canTrack() || !record) return; try { localStorage.setItem(KEY, JSON.stringify(record)); } catch {} }
  function attribution() {
    if (!marketing || permission()?.marketing !== true) return undefined;
    const value = name => (url.searchParams.get(name) || '').trim().toLowerCase();
    let host = ''; try { host = new URL(document.referrer).hostname.toLowerCase(); } catch {}
    const source = value('utm_source');
    const instagram = ['instagram', 'ig'].includes(source) || (!source && /(^|\.)instagram\.com$/.test(host));
    return {
      source: instagram ? 'instagram' : source || (host && host !== location.hostname) ? 'other' : 'unknown',
      medium: ['story', 'stories', 'instagram_story'].includes(value('utm_medium')) ? 'story' : ['social', 'organic_social', 'bio', 'link_in_bio'].includes(value('utm_medium')) ? 'social' : value('utm_medium') ? 'other' : 'none',
      campaign: ['my_garage', 'my-garage', 'garage'].includes(value('utm_campaign')) ? 'my_garage' : value('utm_campaign') ? 'other' : 'none',
      content: ['story', 'reel', 'post', 'bio'].includes(value('utm_content')) ? value('utm_content') : value('utm_content') ? 'other' : 'none'
    };
  }
  function fresh() {
    const visitorId = uid();
    if (!visitorId) return null;
    return {visitorId, expiresAt: new Date(Date.now() + 30 * DAY).toISOString(), signedIn: config.dataset.signedIn === 'true', attribution: attribution()};
  }
  function restore() {
    let old; try { old = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch {}
    if (old && UUID.test(old.visitorId) && Date.parse(old.expiresAt) > Date.now() && Date.parse(old.expiresAt) <= Date.now() + 31 * DAY && !(old.signedIn && config.dataset.signedIn !== 'true')) {
      const validAttribution = old.attribution && ['instagram', 'direct', 'other', 'unknown'].includes(old.attribution.source) && ['story', 'social', 'other', 'none'].includes(old.attribution.medium) && ['my_garage', 'other', 'none'].includes(old.attribution.campaign) && ['story', 'reel', 'post', 'bio', 'other', 'none'].includes(old.attribution.content);
      record = {visitorId: old.visitorId, expiresAt: old.expiresAt, signedIn: config.dataset.signedIn === 'true', ...(marketing && validAttribution ? {attribution: {source: old.attribution.source, medium: old.attribution.medium, campaign: old.attribution.campaign, content: old.attribution.content}} : {}), ...(typeof old.visitToken === 'string' && old.visitToken.length < 2048 ? {visitToken: old.visitToken} : {})};
    } else record = fresh();
    save();
  }
  async function post(body, captureEpoch, retry = true) {
    const controller = new AbortController();
    controllers.add(controller);
    const timer = setTimeout(() => controller.abort(), 3000);
    try {
      const response = await fetch(endpoint.href, {method: 'POST', credentials: 'same-origin', cache: 'no-store', redirect: 'error', referrerPolicy: 'same-origin', keepalive: true, signal: controller.signal, headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)});
      if (captureEpoch !== epoch || !canTrack()) return null;
      if (response.status >= 500) throw new Error('Measurement temporarily unavailable');
      const data = await response.json();
      if (captureEpoch !== epoch || !canTrack()) return null;
      if (data.status === 'EXCLUDED') { excluded = true; reset(false); return null; }
      if (['VISITOR_CHANGED', 'EXPIRED', 'WITHDRAWN'].includes(data.status)) { reset(false); if (canTrack()) {record = fresh(); save();} return null; }
      if (!response.ok || data.status !== 'RECORDED') return null;
      return data;
    } catch {
      if (retry && captureEpoch === epoch && canTrack()) return post(body, captureEpoch, false);
      return null;
    } finally { clearTimeout(timer); controllers.delete(controller); }
  }
  function acceptToken(data, captureEpoch) {
    if (captureEpoch !== epoch || !canTrack() || !record || typeof data?.visitToken !== 'string' || !data.visitToken || data.visitToken.length > 2048 || !Number.isFinite(Date.parse(data.expiresAt)) || Date.parse(data.expiresAt) <= Date.now() || Date.parse(data.expiresAt) > Date.now() + 31 * DAY) return false;
    record.visitToken = data.visitToken;
    record.expiresAt = data.expiresAt;
    save();
    tagCart(record.visitToken);
    scheduleCartRead();
    return true;
  }
  function base(operation, surface, eventId = uid()) {
    if (!record || !eventId) return null;
    return {schemaVersion: 1, operation, visitorId: record.visitorId, eventId, analyticsAllowed: true, marketingAllowed: marketing && permission()?.marketing === true, surface};
  }
  async function ensureVisit(recover = true) {
    if (!canTrack()) return false;
    if (registration) return registration;
    if (registered && record?.visitToken && Date.parse(record.expiresAt) > Date.now()) return true;
    if (!record || Date.parse(record.expiresAt) <= Date.now()) {record = fresh(); save();}
    const body = base('visit', 'page');
    if (!body) return false;
    if (record.attribution && body.marketingAllowed) body.attribution = record.attribution;
    if (record.visitToken) body.visitToken = record.visitToken;
    const captureEpoch = epoch;
    const pending = post(body, captureEpoch).then(data => {const accepted = acceptToken(data, captureEpoch); if (accepted) registered = true; return accepted;});
    registration = pending;
    let accepted;
    try { accepted = await pending; } finally { if (registration === pending) registration = null; }
    if (!accepted && recover && captureEpoch !== epoch && canTrack() && record) return ensureVisit(false);
    return accepted;
  }
  async function event(operation, surface, extra = {}, recover = true) {
    if (!canTrack()) return false;
    if (!await ensureVisit() || !canTrack()) return false;
    const captureEpoch = epoch;
    const body = base(operation, surface);
    if (!body) return false;
    const data = await post({...body, visitToken: record.visitToken, ...extra}, captureEpoch);
    if (!data && recover && captureEpoch !== epoch && canTrack() && record) return event(operation, surface, extra, false);
    return Boolean(data);
  }
  function opened(host, surface = 'drawer') {
    if (!host?.isConnected) return;
    host.dataset.sacGarageTrackingOpen = surface;
    if (document.hidden || !canTrack() || opens.has(host)) return;
    opens.add(host);
    void event('open', surface).then(ok => { if (ok && host.isConnected && host.dataset.sacGarageTrackingOpen === surface && canTrack()) opens.add(host); else if (!ok) opens.delete(host); }).catch(() => {});
  }
  function closed(host) { if (!host) return; opens.delete(host); delete host.dataset.sacGarageTrackingOpen; }
  function scan() { if (document.hidden) return; for (const host of document.querySelectorAll('[data-sac-garage-tracking-open]')) opened(host, host.dataset.sacGarageTrackingOpen === 'page' ? 'page' : 'drawer'); }
  function context() { return canTrack() && record?.visitToken && Date.parse(record.expiresAt) > Date.now() ? {visitToken: record.visitToken, analyticsAllowed: true} : undefined; }
  function allocations(cart) {
    if (!cart || cart.currency !== 'USD' || !Array.isArray(cart.items) || !Number.isInteger(cart.item_count) || cart.item_count <= 0) return [];
    const totals = new Map();
    const add = (application, amount) => { if (application?.type !== 'discount_code' || !CODE.test(application.title || '') || !Number.isSafeInteger(amount) || amount <= 0) return; const code = application.title.toUpperCase(); totals.set(code, (totals.get(code) || 0) + amount); };
    for (const row of Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : []) add(row, row?.total_allocated_amount);
    for (const item of cart.items) for (const row of Array.isArray(item?.line_level_discount_allocations) ? item.line_level_discount_allocations : []) add(row?.discount_application, row?.amount);
    return [...totals].filter(([,amount]) => Number.isSafeInteger(amount) && amount > 0).sort(([a],[b]) => a.localeCompare(b)).slice(0, 2).map(([code, amountCents]) => ({code, amountCents}));
  }
  function cartObserved(cart) {
    if (!canTrack()) return;
    const rows = allocations(cart), signature = JSON.stringify(rows);
    if (!rows.length) { cartSignature = ''; return; }
    if (cartSignature === signature) return;
    cartSignature = signature;
    void event('cart', 'cart', {currency: 'USD', allocations: rows}).then(ok => {if (!ok && cartSignature === signature) cartSignature = '';}).catch(() => {});
  }
  function cartBusy() { try { return window.SacLmCart?.state?.busy || window.SacCityRewardAutoApply?.busy?.() === true; } catch { return true; } }
  function scheduleCartRead() {
    clearTimeout(cartReadTimer);
    if (canTrack()) cartReadTimer = setTimeout(() => void readCart(), 200);
  }
  async function readCart() {
    if (cartReadPending || document.hidden || !canTrack() || !record?.visitToken) return;
    cartReadPending = true;
    const captureEpoch = epoch, controller = new AbortController(), timer = setTimeout(() => controller.abort(), 2500);
    controllers.add(controller);
    try {
      const response = await fetch(cartReadUrl.href, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
      if (!response.ok || captureEpoch !== epoch || !canTrack()) return;
      const cart = await response.json();
      if (captureEpoch === epoch && canTrack()) cartObserved(cart);
    } catch {} finally { clearTimeout(timer); controllers.delete(controller); cartReadPending = false; }
  }
  function tagCart(token) {
    cartDesired = token || '';
    cartAttempts = 0;
    cartFailures = 0;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => void updateCartTag(), 100);
  }
  async function updateCartTag() {
    if (cartPending || cartDesired === null || cartDesired === cartWritten || (cartDesired && !canTrack())) return;
    if ((document.hidden && cartDesired) || cartBusy()) { if (++cartAttempts < 20) cartTimer = setTimeout(() => void updateCartTag(), 250); return; }
    const desired = cartDesired;
    cartPending = true;
    const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 2500);
    try {
      const response = await fetch(cartUrl.href, {method: 'POST', credentials: 'same-origin', keepalive: true, signal: controller.signal, headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {[CART_KEY]: desired}})});
      if (response.ok) cartWritten = desired;
    } catch {} finally {
      clearTimeout(timer);
      cartPending = false;
      if (cartDesired !== desired) cartTimer = setTimeout(() => void updateCartTag(), 0);
      else if (cartWritten !== desired && cartFailures++ < 1) cartTimer = setTimeout(() => void updateCartTag(), 250);
    }
  }
  function withdraw(old, analyticsAllowed = false) {
    if (!old || !UUID.test(old.visitorId)) return;
    const eventId = uid(); if (!eventId) return;
    const body = {schemaVersion: 1, operation: 'withdraw', visitorId: old.visitorId, eventId, analyticsAllowed, marketingAllowed: false, surface: 'page', ...(typeof old.visitToken === 'string' && old.visitToken.length < 2048 ? {visitToken: old.visitToken} : {})};
    try { void fetch(endpoint.href, {method: 'POST', credentials: 'same-origin', keepalive: true, cache: 'no-store', referrerPolicy: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)}).catch(() => {}); } catch {}
  }
  function reset(revoke) {
    const old = record;
    epoch++;
    for (const controller of controllers) controller.abort();
    controllers.clear();
    registration = null;
    registered = false;
    record = null;
    cartSignature = '';
    clearTimeout(cartReadTimer);
    opens = new WeakSet();
    storageRemove();
    tagCart('');
    if (revoke) withdraw(old);
  }
  function consentChanged() {
    const next = permission();
    if (!next) return;
    const hadMarketing = marketing;
    marketing = next.marketing;
    if (excluded) return;
    if (!next.analytics) {
      if (!initialized) { try { record = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch {} }
      if (record || allowed) reset(true);
      allowed = false;
      initialized = true;
      return;
    }
    const first = !allowed;
    allowed = true;
    if (first) restore();
    else if (hadMarketing && !marketing && record) {
      epoch++;
      for (const controller of controllers) controller.abort();
      controllers.clear();
      registration = null;
      registered = false;
      delete record.attribution;
      save();
      withdraw(record, true);
    }
    else if (!hadMarketing && marketing && record && !record.attribution) { record.attribution = attribution(); save(); }
    initialized = true;
    void ensureVisit().then(scan).catch(() => {});
  }
  window.SacGarageTracking = Object.freeze({opened, closed, context, cartObserved});
  if (url.searchParams.get('sac_garage_qa') === '1') {
    let old; try { old = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch {}
    if (old) { storageRemove(); withdraw(old); tagCart(''); }
  }
  document.addEventListener('visitorConsentCollected', consentChanged);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) {consentChanged(); scheduleCartRead(); void updateCartTag();} });
  for (const name of ['on:cart:add', 'on:line-item:change']) document.addEventListener(name, scheduleCartRead);
  for (const name of ['aftersell-upcart:public-events:cart-loaded', 'aftersell-upcart:public-events:cart-updated']) window.addEventListener(name, scheduleCartRead);
  window.addEventListener('pageshow', () => {consentChanged(); scan();});
  let loadAttempts = 0, loading = false;
  function loadPrivacy() {
    if (excluded) return;
    if (permission()) {consentChanged(); return;}
    if (typeof window.Shopify?.loadFeatures === 'function' && !loading) {
      loading = true;
      try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {loading = false; if (!error) consentChanged();}); } catch { loading = false; }
    }
    if (++loadAttempts < 20) setTimeout(loadPrivacy, 500);
  }
  loadPrivacy();
})();
